export default __webpack_public_path__ + "static/media/waste_to_recycle-dk.d10defb3.svg";